import { format, startOfDay } from "date-fns"; // Import date-fns functions
import React from "react";
import { useDetailsFilters } from "../RouteDetails/DetailsFilterContext";
import { DateFilter } from "../shared/DateFilter";
import { EventTypeFilter } from "../shared/EventFilter";
import { RouteFilter } from "../shared/RouteFilter";
import { useFilters } from "./FilterContext";

interface Props {
  excludeRoute?: boolean;
  details?: boolean;
}

export const FilterRow: React.FC<Props> = ({ excludeRoute, details = false }) => {

  console.log("FilterRow", excludeRoute, details);
  const { setFilters: dashboardSetFilters } = useFilters();
  const { setFilters: detailsSetFilters } = useDetailsFilters();

  const formatDateWithoutTime = (date: Date | null): string | null => {
    if (!date) return null;
    return format(startOfDay(date), "MM-dd-yyyy");
  };

  return (
    <div className="flex justify-start items-center my-4">
      <div className="">
        <DateFilter
          onChange={(start: Date | null, end: Date | null) => {
            const formattedStartDate = formatDateWithoutTime(start);
            const formattedEndDate = formatDateWithoutTime(end);


            if (details) {
              detailsSetFilters((prevFilters) => ({
                ...prevFilters,
                startDate: formattedStartDate ?? null,
                endDate: formattedEndDate ?? null,
              }));

              return;
            }

            dashboardSetFilters((prevFilters) => ({
              ...prevFilters,
              startDate: formattedStartDate ?? null,
              endDate: formattedEndDate ?? null,
            }));
          }}
        />
      </div>
      {!excludeRoute && (
        <div>
          <RouteFilter />
        </div>
      )}
      <div>
        <EventTypeFilter details={details} />
      </div>
    </div>
  );
};